import { Navigate, Outlet, useLocation } from "react-router-dom";
import { isLibraryAdminAuthenticated } from "@libraryadmin/services/auth";

export function ProtectedLibraryRoute() {
  const location = useLocation();

  if (!isLibraryAdminAuthenticated()) {
    return (
      <Navigate
        to="/vault-library-admin"
        replace
        state={{ from: `${location.pathname}${location.search}` }}
      />
    );
  }

  return <Outlet />;
}
